import { render, staticRenderFns } from "./RepairsIdleSummary.vue?vue&type=template&id=536e9942&scoped=true"
import script from "./RepairsIdleSummary.vue?vue&type=script&lang=js"
export * from "./RepairsIdleSummary.vue?vue&type=script&lang=js"
import style0 from "./RepairsIdleSummary.vue?vue&type=style&index=0&id=536e9942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536e9942",
  null
  
)

export default component.exports